import React, { useMemo } from 'react';

interface IListMenuProps {
    isShow: boolean;
    children?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    onShowChange: (checked: boolean) => void;
}

const ListMenu = (props: IListMenuProps) => {
    const { isShow, children } = props;

    return <>{isShow && children ? children : null}</>;
};

export default ListMenu;
